// extracted by mini-css-extract-plugin
module.exports = {"uikit-static-select":"uikit-static-select__1TWLI"};